import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { Organization } from 'src/app/shared/models/organization.model';
import { SharedService } from 'src/app/shared/shared.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { Price, PricesService } from './prices.service';

@Component({
    selector: 'app-update-prices',
    templateUrl: './update-prices.component.html',
    styleUrls: ['./update-prices.component.css'],
    standalone: false
})
export class UpdatePricesComponent implements OnInit {

  public currentOrganizationId: number;
  public price: Price = new Price;
  public icons: { [name: string]: any } = {
    'faLink': faLink
  };

  private _organization: Organization;

  constructor(private _activatedRoute: ActivatedRoute, private _router: Router, private _priceService: PricesService,
    private _toastService: ToastService, private _sharedService: SharedService) {

      this._toastService.remove();
    }

  ngOnInit(): void {
    const urlPramas = this._activatedRoute.snapshot.params;
    if (!urlPramas.orgId) {
      this._router.navigate(['/']);
    }

    this._sharedService.getOrganization(urlPramas.orgId).subscribe(requestResult => {
      this._organization = requestResult;
      this._sharedService.organizationNameSubject.next({ 'de': this._organization.name_de, 'it': this._organization.name_it });
    }, requestError => {
      console.log(requestError);
    });

    this.currentOrganizationId = urlPramas.orgId;
    this._priceService.getSchedulesOfOrganiaztion(this.currentOrganizationId).subscribe(() => { }, error => {
      console.log(error);
    });

    this._priceService.priceSubject.subscribe(result => {
      this.price = result;
    });
  }

  onSavePriceButtonClick() {
    this._priceService.updatePrices(this.price, this.currentOrganizationId.toString())
      .subscribe(result => {
        console.log('QUI');
        this._toastService.show('', {
          classname: 'bg-success text-light',
          delay: 2000,
          autohide: true,
        });
      }, error => {
        console.log(error);
      });
  }

}
